export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-3a-f600a79bd5f9d568c0afac055db0f847.webp";